import { Link as AriaLink, type LinkProps as AriaLinkProps } from "react-aria-components";
import React from "react";
import type { ReactElement } from "react";
import type { VariantProps } from "tailwind-variants";

import { cn } from "@/lib/helpers/cn";
import ExternalIcon from "@/assets/images/icons2/icon--external-link.svg";

import { buttonStyles } from "./Button";

type LinkProps = {
  icon?: ReactElement;
  isExternal?: boolean;
  rawChildren?: boolean;
} & AriaLinkProps &
  Pick<VariantProps<typeof buttonStyles>, "size" | "variant">;

export function Link2({
  children,
  className,
  icon: Icon,
  isExternal,
  rawChildren,
  size,
  variant = "link",
  ...linkProps
}: LinkProps) {
  const { body, content, icon: iconStyle } = buttonStyles({ hasIcon: !!Icon, size, variant });

  return (
    <AriaLink
      className={cn(body(), "atom-focus tw:no-underline!", className)}
      {...(isExternal && { rel: "noopener noreferrer", target: "_blank" })}
      {...linkProps}
    >
      {rawChildren && children}

      {!rawChildren && (
        <>
          <span className={cn(content(), "tw:no-underline!")}>
            {Icon &&
              React.cloneElement(Icon, {
                className: cn(iconStyle(), Icon.props.className),
              })}

            <span className="trim-both tw:empty:hidden">{children}</span>
          </span>

          {isExternal && <img alt="" className="tw:ml-2 tw:align-text-top!" src={ExternalIcon} />}
        </>
      )}
    </AriaLink>
  );
}
